export const getVisibilityEffects = async ({ bffUri, classifieds = [], }) => {
    if (classifieds.length === 0) {
        return {};
    }
    const response = await fetch([bffUri, 'visibility-effects'].join(''), {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json; charset=utf-8',
        },
        body: JSON.stringify({ classifieds }),
        signal: AbortSignal.timeout(5000),
    });
    if (response.ok) {
        return (await response.json());
    }
    return {};
};
